import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferBadge: Partial<Record<OfferKindEnum, string>> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: 'Dodatkowe {{percentageAmount}}% zniżki',
  [OfferKindEnum.PercentageOffByProducts]: 'Dodatkowe {{percentageAmount}}% zniżki',
  [OfferKindEnum.AmountOffByProducts]: 'Dodatkowe {{amount}} zniżki',
  [OfferKindEnum.Bogo]: '2 W CENIE 1',
  [OfferKindEnum.BogoHalfPrice]: 'Kup 1, drugi za pół ceny!',
  [OfferKindEnum.FreeItemByProducts]: 'Gratis',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Gratis',
};

export default OfferBadge;
